export default {
    jobs: [],
    jobsLoading: false,
    jobPlates: [],
    jobPlatesLoading: false,
    machines: [],
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        machineIds: []
    }
}